import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { remove } from 'lodash'
import { BaseService } from './base.service';

export enum NotificationType {
    INFO,
    WARNING,
    ERROR
}

export interface INotification {
  id?: number,
  type?: NotificationType;
  title?: string;
  message: string;
  msgCod?: string;
  replacements?: any;
  issuedAt?: Date;
  timeout?: number;
  closeFn?: any;
}

const DEFAULTS = {
  timeout: 0,
  type: NotificationType.INFO,
  title: 'Info'
}

@Injectable()
export class NotificationsService extends BaseService {

  notifications: INotification[] = []
  i:number = 0

  constructor() {
    super()
    console.log('NotificationsService constructor', this.getId())
  }

  notifyInfo (notification: INotification) {
    return this.notify({ ...notification, type: NotificationType.INFO })
  }
  notifyWarning (notification: INotification) {
    return this.notify({ title: 'Warning', ...notification, type: NotificationType.WARNING })
  }
  notifyError (notification: INotification) {
    return this.notify({ title: 'Error', ...notification, type: NotificationType.ERROR })
  }

  notify (notification: INotification) {
    // const id = this.notifications[this.notifications.length - 1]
    //   ? this.notifications[this.notifications.length - 1].id + 1
    //   : 1
    const id = this.i++
    const not = { ...DEFAULTS, ...notification, id, issuedAt: new Date() }
    this.notifications.push(not)
    return not
  }

  closeNotification (notification: INotification) {
    if(notification) {
      if(notification.closeFn) {
        notification.closeFn()
      } else {
        remove(this.notifications, (not: INotification) => not.id === notification.id)
      }
    }
  }

  clearAll() {
    this.notifications.length = 0
  }

  getNotifications () {
    return this.notifications
  }

}
